import { render } from "./SR3.vue?vue&type=template&id=6e5813ae"
import script from "./SR3.vue?vue&type=script&lang=js"
export * from "./SR3.vue?vue&type=script&lang=js"

import "./SR3.vue?vue&type=style&index=0&id=6e5813ae&lang=css"
script.render = render

export default script